module.exports = __webpack_public_path__ + "1.5.0-unryo/img/influxdb.eb56f81c.svg";